module.exports = __webpack_public_path__ + "img/btn_sound_on.15cb30dd.png";